import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input, DatePicker } from "components";
import NumberFormat from "react-number-format";
import { Button, FlexRow, LineButton } from "appStyles";
import { priceToDollars, formatDollarsToCents } from "helpers";
import styled, { css } from "react-emotion";
import CloseIcon from "@material-ui/icons/Close";
import Switch from "@material-ui/core/Switch";
import { withStyles } from "@material-ui/core/styles";

import { RadioGroup, FormControlLabel, Radio } from "@material-ui/core";

const inputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;
const boldButton = css`
  display: inline-block;
  width: 100px;
  text-align: center;
  border-radius: 5.5px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
`;

const titleStyle = css`
  white-space: nowrap;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const H2 = styled("h2")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 20px;
  line-height: 18px;
  color: #1f3747;
  margin: auto;
`;

const MySwitch = withStyles({
  switchBase: {
    color: "white",
    "&$checked": {
      color: "#89d2d3",
    },
    "&$checked + $track": {
      backgroundColor: "#89d2d3",
    },
  },
  checked: {},
  track: {},
})(Switch);

const Coupon = (props) => {
  const {
    id,
    minimumOrderValue,
    finePrint,
    maxRedemptions,
    maxRedemptionsPerUser,
    maxDiscount,
    amountOff,
    percentOff,
    code,
    expiration,
    retired,
    isValid,
    isPublic,
  } = props.coupon;

  const { coupon, appId } = props;
  // console.dir(coupon);

  const createCoupon = () => {
    if (coupon.code && (coupon.percentOff || coupon.amountOff)) {
      props
        .createCoupon(appId, {
          appId: appId,
          ...props.coupon,
        })
        .then((coupon) => {
          if (coupon.error != undefined) {
            alert("There was an issue creating your promo code.");
          }
        });
      props.toggleCouponModal(false);
      props.updateActiveEditor(null);
    } else {
      alert("Promo code and type amount or percent cannot be empty");
    }
  };

  const deleteCoupon = () => {
    props.deleteCoupon(coupon, appId);
    props.toggleCouponModal(false);
  };

  const update = (field) => (value) => {
    if (
      field === "amountOff" ||
      field === "maxDiscount" ||
      field === "minimumOrderValue"
    ) {
      value = formatDollarsToCents(value["value"]);
    }

    if (field === "percentOff") {
      value = value["floatValue"];
    }

    props.updateCoupon({
      ...props.coupon,
      [field]: value,
    });
  };

  const handleChange = (e) => {
    setCouponType(e.target.value);
    if (e.target.value === "percentOff") {
      props.updateCoupon({
        ...props.coupon,
        ["amountOff"]: null,
      });
    } else {
      props.updateCoupon({
        ...props.coupon,
        ["percentOff"]: null,
        ["maxDiscount"]: null,
      });
    }
  };

  const handleToggleChange = (event) => {
    // console.log(event);
    props.updateCoupon({
      ...props.coupon,
      [event.target.name]: event.target.checked,
    });
  };

  const isNewCoupon = id === "newCoupon";

  const isRetired = retired === 1 || !isValid ? true : false;

  const getCouponType = () => {
    if (amountOff) {
      return "amountOff";
    } else {
      return "percentOff";
    }
  };

  const [couponType, setCouponType] = useState(getCouponType());

  // Input Fields Control
  const [showMaxDiscount, setShowMaxDiscount] = useState(
    maxDiscount ? true : false
  );
  const [showExpiration, setShowExpiration] = useState(
    expiration ? true : false
  );
  const [showMinOrderVal, setShowMinOrderVal] = useState(
    minimumOrderValue ? true : false
  );
  const [showLimitUse, setShowLimitUse] = useState(
    maxRedemptions ? true : false
  );

  const [showLimitCustomerUse, setShowLimitCustomerUse] = useState(
    maxRedemptionsPerUser ? true : false
  );

  const toggleMaxDiscount = () => {
    setShowMaxDiscount(!showMaxDiscount);
    if (showMaxDiscount) {
      props.updateCoupon({
        ...props.coupon,
        ["maxDiscount"]: null,
      });
    }
  };
  const toggleExpiration = () => {
    setShowExpiration(!showExpiration);
  };
  const toggleMinOrderVal = () => {
    setShowMinOrderVal(!showMinOrderVal);
  };
  const toggleLimitUse = () => {
    setShowLimitUse(!showLimitUse);
  };
  const toggleLimitCustomerUse = () => {
    setShowLimitCustomerUse(!showLimitCustomerUse);
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "1.5em",
        color: "black",
        overflowY: "auto",
        height: "98%",
      }}
    >
      <div>
        <div
          style={{
            padding: "1em",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {isNewCoupon && <H2 style={{ marginBottom: "20px" }}>New Coupon</H2>}
          {!isNewCoupon && (
            <H2 style={{ marginBottom: "20px" }}>Coupon Details</H2>
          )}
          <span
            style={{
              cursor: "pointer",
              color: "black",
              fontSize: "22px",
            }}
            onClick={() => props.toggleCouponModal(false)}
          >
            <CloseIcon></CloseIcon>
          </span>
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span className={titleStyle}>Coupon Code</span>
          <div style={{ width: "40%", marginBottom: "15px" }}>
            <Input
              field="FIRSTTIMER"
              name="Promo Code"
              validateInput="true"
              defaultValue={code}
              onChange={update("code")}
              disabled={id != "newCoupon"}
              textColor={id != "newCoupon" ? "gray" : "rgb(31, 55, 71)"}
              background={id != "newCoupon" ? "lightgrey" : "white"}
            />
          </div>
          <p className={titleStyle}>Type</p>
          <RadioGroup
            aria-label="couponType"
            name="couponType"
            value={couponType}
            onChange={handleChange}
          >
            <FormControlLabel
              value={"percentOff"}
              control={<Radio />}
              label="Percent Off"
              disabled={id != "newCoupon"}
            />
            <FormControlLabel
              value={"amountOff"}
              control={<Radio />}
              label="Fixed Amount Off"
              disabled={id != "newCoupon"}
            />
          </RadioGroup>
          <span className={titleStyle}>
            {couponType === "percentOff" ? "Percentage off" : "Amount off"}
          </span>
          {couponType === "percentOff" ? (
            <div style={{ width: "40%", marginBottom: "15px" }}>
              <NumberFormat
                placeholder="15%"
                thousandSeparator={true}
                suffix={"%"}
                required
                isAllowed={(values) => {
                  const { formattedValue, floatValue } = values;
                  if (floatValue == null) {
                    return formattedValue === "";
                  } else {
                    return floatValue <= 100 && floatValue >= 0;
                  }
                }}
                decimalScale={0}
                fixedDecimalScale={true}
                allowNegative={false}
                allowLeadingZeros={false}
                defaultValue={percentOff}
                onValueChange={update("percentOff")}
                className={inputStyle}
                disabled={id != "newCoupon"}
                style={{
                  backgroundColor: id != "newCoupon" ? "lightgrey" : "white",
                  color: id != "newCoupon" ? "gray" : "rgb(31, 55, 71)",
                }}
              />{" "}
            </div>
          ) : (
            <div style={{ width: "40%", marginBottom: "10px" }}>
              <NumberFormat
                placeholder="$20"
                thousandSeparator={true}
                prefix={"$"}
                required
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                allowLeadingZeros={false}
                defaultValue={amountOff ? priceToDollars(amountOff) : null}
                onValueChange={update("amountOff")}
                className={inputStyle}
                disabled={id != "newCoupon"}
                style={{
                  backgroundColor: id != "newCoupon" ? "lightgrey" : "white",
                  color: id != "newCoupon" ? "gray" : "rgb(31, 55, 71)",
                }}
              />
            </div>
          )}

          {couponType === "percentOff" && (
            <div style={{ marginBottom: "15px" }}>
              <div className={titleStyle}>
                <span className={titleStyle}>Set Max Discount</span>
                {/* <input /> */}
                <MySwitch
                  type="checkbox"
                  onChange={toggleMaxDiscount}
                  checked={showMaxDiscount}
                  disabled={id != "newCoupon"}
                />
              </div>
              {showMaxDiscount && (
                <div style={{ width: "40%" }}>
                  <NumberFormat
                    placeholder="$10"
                    thousandSeparator={true}
                    prefix={"$"}
                    decimalScale={2}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    allowLeadingZeros={false}
                    defaultValue={
                      maxDiscount ? priceToDollars(maxDiscount) : null
                    }
                    onValueChange={update("maxDiscount")}
                    className={inputStyle}
                    disabled={id != "newCoupon"}
                    style={{
                      backgroundColor:
                        id != "newCoupon" ? "lightgrey" : "white",
                      color: id != "newCoupon" ? "gray" : "rgb(31, 55, 71)",
                    }}
                  />
                </div>
              )}
            </div>
          )}
          <span className={titleStyle}>Fine Print (Optional)</span>
          <div style={{ width: "70%", marginBottom: "15px" }}>
            <Input
              name="Fine Print"
              field="Valid only on purchases through app."
              defaultValue={finePrint}
              onChange={update("finePrint")}
              disabled={id != "newCoupon"}
              textColor={id != "newCoupon" ? "gray" : "rgb(31, 55, 71)"}
              background={id != "newCoupon" ? "lightgrey" : "white"}
            />
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              alignSelf: "flex-start",
            }}
          >
            <p
              style={{
                fontSize: "15px",
                margin: "15px 0px",
                marginRight: "15px",
              }}
            >
              Publicly Display this Coupon to Customers
            </p>
            <MySwitch
              checked={isPublic}
              onChange={handleToggleChange}
              name="isPublic"
              inputProps={{ "aria-label": "primary checkbox" }}
              disabled={id != "newCoupon"}
            />
          </div>

          <div className={titleStyle}>
            <span className={titleStyle}>Set Expiration</span>
            <MySwitch
              inputProps={{ "aria-label": "primary checkbox" }}
              onChange={toggleExpiration}
              checked={showExpiration}
              disabled={id != "newCoupon"}
            />
          </div>
          {showExpiration && (
            <div style={{ width: "70%" }}>
              <DatePicker
                datePickerProps={{
                  showTimeSelect: true,
                  timeFormat: "hh:mm a",
                  timeIntervals: 10,
                  timeCaption: "time",
                  dateFormat: "MM/dd/yyyy hh:mm a",
                  style: {
                    marginLeft: "0px",
                    marginTop: "10px",
                    innerWidth: "200px",
                    innerBackgroundPosition: "175px center",
                  },
                }}
                isExpirationDate={true}
                title="Expiration Date:"
                selected={expiration}
                onChange={update("expiration")}
                disabled={id != "newCoupon"}
              />
            </div>
          )}
          <div className={titleStyle}>
            <span className={titleStyle}>Require Minimum Order Value</span>
            <MySwitch
              onChange={toggleMinOrderVal}
              checked={showMinOrderVal}
              disabled={id != "newCoupon"}
            />
          </div>
          {showMinOrderVal && (
            <div style={{ width: "40%" }}>
              <NumberFormat
                placeholder="$20"
                thousandSeparator={true}
                prefix={"$"}
                decimalScale={2}
                fixedDecimalScale={true}
                allowNegative={false}
                allowLeadingZeros={false}
                defaultValue={
                  minimumOrderValue ? priceToDollars(minimumOrderValue) : null
                }
                onValueChange={update("minimumOrderValue")}
                className={inputStyle}
                disabled={id != "newCoupon"}
                style={{
                  backgroundColor: id != "newCoupon" ? "lightgrey" : "white",
                  color: id != "newCoupon" ? "gray" : "rgb(31, 55, 71)",
                }}
              />
            </div>
          )}
          <div className={titleStyle}>
            <span className={titleStyle}>
              Limit number of times this coupon can be used
            </span>
            <MySwitch
              onChange={toggleLimitUse}
              checked={showLimitUse}
              disabled={id != "newCoupon"}
            />
          </div>
          {showLimitUse && (
            <div style={{ width: "40%" }}>
              <Input
                field="1"
                name="maxRedemptions"
                type="number"
                defaultValue={maxRedemptions}
                onChange={update("maxRedemptions")}
                disabled={id != "newCoupon"}
                textColor={id != "newCoupon" ? "gray" : "rgb(31, 55, 71)"}
                background={id != "newCoupon" ? "lightgrey" : "white"}
              />
            </div>
          )}
          <div className={titleStyle}>
            <span className={titleStyle}>
              Limit number of times a customer can use this coupon
            </span>
            <MySwitch
              onChange={toggleLimitCustomerUse}
              checked={showLimitCustomerUse}
              disabled={id != "newCoupon"}
            />
          </div>
          {showLimitCustomerUse && (
            <div style={{ width: "40%" }}>
              <Input
                field="5"
                name="maxRedemptions"
                type="number"
                defaultValue={maxRedemptionsPerUser}
                onChange={update("maxRedemptionsPerUser")}
                disabled={id != "newCoupon"}
                textColor={id != "newCoupon" ? "gray" : "rgb(31, 55, 71)"}
                background={id != "newCoupon" ? "lightgrey" : "white"}
              />
            </div>
          )}
          {isNewCoupon && (
            <FlexRow style={{ justifyContent: "flex-end", height: "auto" }}>
              <Button
                className={boldButton}
                background="#89D2D3"
                onClick={createCoupon}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  width: "auto",
                  textAlign: "center",
                  marginLeft: "20px",
                  height: "42px",
                  boxShadow: "3px 3px 13px rgba(120, 120, 120, 0.5)",
                }}
              >
                Create Coupon
              </Button>
            </FlexRow>
          )}
        </div>
        {!isNewCoupon && !isRetired && (
          <div>
            {" "}
            <LineButton
              color="#F17F7F"
              onClick={deleteCoupon}
              className={boldButton}
              style={{ width: "auto", marginRight: "20px" }}
            >
              Delete
            </LineButton>
          </div>
        )}
      </div>
    </div>
  );
};

Coupon.propTypes = {
  deal: PropTypes.object,
  putDeal: PropTypes.func,
  deleteDeal: PropTypes.func,
  updateDeal: PropTypes.func,
  toggleCouponModal: PropTypes.func,
};

export default Coupon;
